import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5efbd4f6")

_pushScopeId("data-v-5efbd4f6")
const _hoisted_1 = { class: "type-wrap" }
const _hoisted_2 = { class: "type-title" }
const _hoisted_3 = { class: "type-item-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_type_item = _resolveComponent("type-item")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('joinUs')), 1),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.communityList, (item, name) => {
        return (_openBlock(), _createBlock(_component_type_item, {
          key: name,
          item: item,
          name: name,
          onJumpFanPage: _ctx.jumpFanPage,
          onGetGift: _ctx.getGift
        }, null, 8, ["item", "name", "onJumpFanPage", "onGetGift"]))
      }), 128))
    ])
  ]))
})